module.exports = __webpack_public_path__ + "img/icon-small-check.a3c49b66.svg";